import type { FilterPill } from '../FilterPills';
import type { EntitlementRow } from '../IncludedEntitlements';

/**
 * Generate filter pills from EntitlementRow[] (excludes deleted entitlements)
 */
// eslint-disable-next-line import/prefer-default-export
export const generateFilterPillsFromEntitlementRows = (
  entitlementRows: EntitlementRow[]
): FilterPill[] => {
  const applications = new Set<string>();
  const entitlementOptions: { label: string; value: string }[] = [];

  entitlementRows.forEach((row) => {
    // Applications filter
    const applicationName = row.endpointDisplayName ?? row.endpointName;

    applications.add(applicationName);

    // Entitlements filter - use evKey as value for consistency with filtering logic
    const entitlementName = row.evDisplayName || row.entitlementValueName;

    entitlementOptions.push({
      label: entitlementName,
      value: String(row.evKey),
    });
  });

  return [
    {
      id: 'applications',
      label: 'Applications',
      options: Array.from(applications).map((app) => ({
        label: app,
        value: app,
      })),
    },
    {
      id: 'entitlements',
      label: 'Entitlements',
      options: entitlementOptions,
    },
    {
      id: 'access_status',
      label: 'Access Status',
      options: [
        { label: 'Present', value: 'present' },
        { label: 'Absent', value: 'absent' },
      ],
    },
  ];
};
